export const isNumeric = (str: string) => {
    return Boolean(str.match(/^[\d]+$/));
};
